var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 79,
    viewBox: "0 0 264 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5277 33.7276C30.739 35.4934 0.5 55.1472 0.5 55.1472V69.0005C0.5 74.5233 4.97715 79.0005 10.5 79.0005H253.5C259.023 79.0005 263.5 74.5234 263.5 69.0005V28.3727C263.5 28.3727 243.114 34.4371 229.512 33.7276C201.874 32.2861 205.11 4.44251 177.722 1.59824C141.345 -2.17943 141.582 39.1723 104.891 41.2245C85.1824 42.3268 75.1928 32.3268 55.5277 33.7276Z",
    fill: "url(#paint0_linear_2294_2858)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 55.1472C0.5 55.1472 30.739 35.4934 55.5277 33.7276C75.1928 32.3268 85.1824 42.3268 104.891 41.2245C141.582 39.1723 141.345 -2.17943 177.722 1.59824C205.11 4.44251 201.874 32.2861 229.512 33.7276C243.114 34.4371 263.5 28.3727 263.5 28.3727",
    stroke: "#64E499",
    strokeWidth: 1.91724,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2294_2858",
    x1: 132,
    y1: 1.35449,
    x2: 132,
    y2: 104.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64E499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphGreen);
export default __webpack_public_path__ + "static/media/graph-green.41044b63c2b4a850d7bcf2b73348047f.svg";
export { ForwardRef as ReactComponent };